"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultsFromStoreLocale = exports.getMeasurementUnit = exports.createStoreLocaleFromCountryCode = exports.removeStoreLocaleFromURL = exports.getStoreLocaleFromURL = exports.getValidCountryCodeFromStoreLocale = exports.getIsSupportedCountryCode = void 0;
// @ts-nocheck
const iso2GeoZones_1 = __importDefault(require("../constants/iso2GeoZones"));
const getIsSupportedCountryCode = (countryCode = '') => {
    const isSupportedCountryCode = iso2GeoZones_1.default[countryCode.toUpperCase()];
    return !!isSupportedCountryCode;
};
exports.getIsSupportedCountryCode = getIsSupportedCountryCode;
const getValidCountryCodeFromStoreLocale = (storeLocale = '') => {
    return storeLocale.replace(/en-/, '').toUpperCase(); // transform `en-mx` => `MX`
};
exports.getValidCountryCodeFromStoreLocale = getValidCountryCodeFromStoreLocale;
const getStoreLocaleFromURL = (url) => {
    const [match, storeLocale] = url.match(/~*^\/(en-[a-z]{2})(?:$|\/)/i) || [];
    return storeLocale || '';
};
exports.getStoreLocaleFromURL = getStoreLocaleFromURL;
const removeStoreLocaleFromURL = (url) => {
    const cleanPath = url.replace(/^\/en-[a-z]{2}/i, '');
    return cleanPath;
};
exports.removeStoreLocaleFromURL = removeStoreLocaleFromURL;
const createStoreLocaleFromCountryCode = (countryCode) => {
    return `en-${countryCode.toLowerCase()}`;
};
exports.createStoreLocaleFromCountryCode = createStoreLocaleFromCountryCode;
const getMeasurementUnit = (countryCode) => {
    return countryCode === 'US' ? 'in' : 'cm';
};
exports.getMeasurementUnit = getMeasurementUnit;
const getDefaultsFromStoreLocale = (storeLocale = '') => {
    if (!storeLocale) {
        return {};
    }
    const countryCode = (0, exports.getValidCountryCodeFromStoreLocale)(storeLocale);
    const measurementUnit = (0, exports.getMeasurementUnit)(countryCode);
    return {
        countryCode: countryCode,
        measurementUnit: measurementUnit,
        storeLocale: storeLocale,
    };
};
exports.getDefaultsFromStoreLocale = getDefaultsFromStoreLocale;
